// UpcomingSessionRow — one row for the dashboard's "Upcoming sessions" card.
import { formatDateTime } from "../../lib/formatDateTime.js";
import type { SessionWithCourse } from "@dm-lms/shared/types";

interface UpcomingSessionRowProps {
  session: SessionWithCourse;
}

export default function UpcomingSessionRow({ session }: UpcomingSessionRowProps) {
  return (
    <div className="flex items-start gap-3 py-2.5">
      <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-blue-500" />
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-semibold text-dm-navy">{session.title}</p>
        <p className="truncate text-xs text-dm-slate">
          {session.courseTitle} · {formatDateTime(session.scheduledAt)}
        </p>
      </div>
    </div>
  );
}
